export const SAVE = "save";
export const ADD_SCHEDULE = "add_schedule";
export const ADD_BUFFER = "add_buffer";
export const PUBLISH_NOW = "publish_now";

export const SAVE_DRAFT = "save_draft";
export const ADD_DRAFT = "add_draft";
export const ADD_FOR_APPROVAL_DRAFT = "add_for_approval_draft";
